export default __webpack_public_path__ + "static/media/diwali.fd66deb7.png";